/**
 * Date utility functions for pricing module
 *
 * This module wraps 1823-core date utilities to maintain backward compatibility.
 * 1823-core returns null for invalid dates, but this module returns '' for backward compatibility.
 */
import {
  formatDate as coreFormatDate,
  formatDateTimeForDisplay as coreFormatDateTimeForDisplay,
  formatDateTimeForSave as coreFormatDateTimeForSave,
  getCurrentUtcTimestamp,
  parseDate,
} from '@1823-partners/core';

/**
 * Formats a date to YYYY-MM-DD string format using UTC time
 * Used for date-only fields like ASOFDT and RECEIVED_DATE
 * @param {string|Date} date - The date to format
 * @returns {string} - Formatted date string in YYYY-MM-DD format, empty string if invalid
 */
export const formatDate = (date) => coreFormatDate(date) ?? '';

/**
 * Formats a datetime for display using locale string
 * Used for displaying datetime fields like MODIFIED_DATE
 * @param {string|Date} datetime - The datetime to format
 * @returns {string} - Formatted datetime string in locale format, empty string if invalid
 */
export const formatDateTimeForDisplay = (datetime) => coreFormatDateTimeForDisplay(datetime) ?? '';

/**
 * Formats a datetime for saving to backend using UTC time
 * Used when saving datetime fields like MODIFIED_DATE
 * @param {string|Date} datetime - The datetime to format
 * @returns {string} - Formatted datetime string in ISO UTC format
 */
export const formatDateTimeForSave = (datetime) => coreFormatDateTimeForSave(datetime) ?? '';

// Re-export functions that don't need wrapping
export { getCurrentUtcTimestamp, parseDate };
